import { fetchRing } from '../core';
import { ringItems } from '../entity_risk/get_entity_risk_scores';
import { sourceRefId } from '../../lib/funnel';

export const BLAST_RADIUS_SCORES_RING = 'blast_radius_scores';

export interface ReachableLayerItem {
  id?: string;
  name?: string;
  matched?: string[];
  criticality?: number | string;
  element_type?: string;
  confidence?: number;
  full_match?: boolean;
  edge?: string;
}

export interface ReachableLayerCache {
  source?: string;
  count?: number;
  items?: ReachableLayerItem[];
}

export interface BlastRadiusScoreDocument {
  _id?: string;
  element_id?: string | { value?: string };
  element_name?: string;
  ebr_score?: number | string;
  severity?: number;
  score?: number | string;
  band?: string;
  reachability_count?: number | string;
  truncated?: boolean;
  max_domain?: string;
  universal_domain?: string;
  model?: string;
  breakdown?: Record<string, number | string>;
  weights?: Record<string, number | string>;
  reachable_nodes?: {
    tree?: Array<{ id: string; hops?: number | string; pred?: string | null; edge?: string }>;
    count?: number;
    truncated?: boolean;
  };
  reachable_infrastructure_elements?: {
    tree?: Array<{ id: string; hops?: number | string; pred?: string | null; edge?: string }>;
    count?: number;
    truncated?: boolean;
  };
  reachable_business_elements?: ReachableLayerCache;
  reachable_adversarial_elements?: ReachableLayerCache;
  path_to_crown_jewel?: Array<{
    from?: string;
    to?: string;
    label?: string;
    hops?: number | string;
  }>;
  crown_jewel?: {
    node_id?: string;
    name?: string;
    criticality_score?: number | string;
  } | null;
  computed_at?: string;
  run_id?: string;
  origin?: string;
  [key: string]: unknown;
}

export function blastElementId(row: Pick<BlastRadiusScoreDocument, 'element_id'>): string {
  return sourceRefId(row.element_id);
}

export async function getBlastRadiusScoresAll(): Promise<BlastRadiusScoreDocument[]> {
  const res = await fetchRing<BlastRadiusScoreDocument>(BLAST_RADIUS_SCORES_RING, { all: true });
  return ringItems<BlastRadiusScoreDocument>(res);
}
